module.exports = __webpack_public_path__ + "static/media/icon_new_left_carousel.9fe6c173.svg";